import React, { useRef, useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import LogoPico from "../assets/LogoPico.svg";

//menu list mobile 
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import InfoIcon from '@mui/icons-material/Info';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import NextWeekIcon from '@mui/icons-material/NextWeek';
import HelpIcon from '@mui/icons-material/Help';
import { Link } from "react-router-dom";

const PublicLayout = () => {

  //abre el menu mobile
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const menuItems = [
    { label: 'Acerca de', icon: <InfoIcon className="text-amarillo" size="md" /> },
    { label: 'Contacto', icon: <ContactSupportIcon className="text-amarillo" size="md" /> },
    { label: 'Portfolio', icon: <NextWeekIcon className="text-amarillo" size="md" /> },
    { label: 'Preguntas Frecuentes', icon: <HelpIcon className="text-amarillo" size="md" /> },
  ];

  const MobileMenu = (
    <Box sx={{ width: 270 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {menuItems.map(({ label, icon }) => (
          <ListItem key={label} disablePadding>
            <ListItemButton>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );


  return (
    <div className="w-full h-screen overflow-y-auto bg-ceniza" style={{zIndex: 9000}}>
      <nav className="block p-3 w-[100%] text-white bg-ceniza shadow-lg  ">
        <div className="container flex flex-wrap items-center justify-between mx-auto text-gray-100">
          {/* Logo */}
          <a
            href="#"
            className="text-blanco font-worksans text-[20px] font-bold leading-[23px] tracking-[-0.4px] uppercase no-underline flex"
          >
            <img
              className="w-[38px] h-[38px] mx-auto"
              src={LogoPico}
              alt="logo"
            />
            <span className="mt-3 text-[#484d50]"> SmartMine </span>
            <span className="mt-3 text-[#c2a435]"> Code </span>
          </a>

          <div className="hidden lg:block">
            <ul className="flex flex-col gap-2 mt-2 mb-4 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
              <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                <Link to="/" className="flex items-center">
                  Acerca de
                </Link>
              </li>
              <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                <Link to="/" className="flex items-center">
                  Contacto
                </Link>
              </li>
              <li className="flex items-center p-1 text-sm gap-x-2 ">
                <Link to="/" className="flex items-center">
                  Portafolio
                </Link>
              </li>
              <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                <Link to="/" className="flex items-center">
                  Preguntas Frecuentes
                </Link>
              </li>
            </ul>
          </div>

          {/* Boton */}
          <button
            onClick={toggleDrawer(true)}
            className="relative ml-auto h-6 max-h-[40px] w-6 max-w-[40px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-inherit transition-all hover:bg-transparent focus:bg-transparent active:bg-transparent disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none lg:hidden"
            type="button"
          >
            <span className="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </span>
          </button>

          {/* Menu mobile */}
          <Drawer 
            open={open}
            onClose={toggleDrawer(false)} 
            PaperProps={{
              sx: { backgroundColor: "#17181a", color: "#fffcfc" } // color opcional del texto
          }}>
            {MobileMenu}
          </Drawer>

        </div>
      </nav>

      {/* Aquí se insertará la ruta hija */}
      <div className="p-5">
        <Outlet />
      </div>
    </div>
  );
};

export default PublicLayout;
